import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Navigation from '../navigation/navigationVisiteur';
import PostAffichage from './postAffichage';
import Notification from '../messagerie_user/notification';
import NavJoueur from '../navigation/navJoueur';


function PostJoueur() {
    const Navigate = useNavigate();
    const [userData, setUserData] = useState(null);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [type,setType] = useState(null)
    const apiUrl = process.env.REACT_APP_API_URL;
  
  
    useEffect(() => {
      setIsLoading(true);
      const fetchData = async () => {
        try {
          const response = await axios.post(
            `${apiUrl}/verification/cookie`,
            {},
            {
              withCredentials: true 
            }
          );
          setUserData(response.data);
          setError(null);
          setIsLoading(false);
          setType(response.data.user.type + "s")
          if (response.data.user.type !== "joueur") {
            Navigate('/connexion');
          }
          else if(response.data.isRetardCotisation === true){
            Navigate('/joueurs/accueil/cotisation')
          }
  
        } catch (error) {
          if (error.response) {
              
            setError(error.response.data.message);
          } else {
            Navigate('/connexion')
            setError(true)
          }
  
        }
      };
  
      fetchData(); 
    }, [Navigate, apiUrl]);



    if (isLoading) {
      return (
      <div className="centered-content">
        <img src="/img/logo.png" alt="Logo" className="centered-logo" />
        <br/>
        <span className="loader"></span>
      </div>
      
      );  
    }




  return (
    
    <>
    {userData ? (
      <>
        <NavJoueur userData={userData} nom='Post'/>
          <div className="main post">
            <Notification  userData = {userData}/>
            <div className='post1'>
            <div className="publi2">
                <div className="nom1">
                    <img src={`${apiUrl}/image/equipe/${userData.user.donnée.results[0].logo}`} alt="logo de l'equipe"  />
                </div>
                  <div className="post-header">
                    <h3><a href={`/joueurs/equipe/${userData.user.donnée.results[0].id_equipe}`}>{userData.user.donnée.results[0].nom_equipe} {"("} {userData.user.donnée.results[0].categorie} {")"} </a></h3>
                </div>
              </div>
            </div>
            <br/>
            <PostAffichage userData={userData} type={type}/>
          </div>
      </>
          ) : (
            <>
            <Navigation/>        
            <div id="alert-message" className="alert" >
                <strong>ERROR ! </strong>{error} <span id="alert-text"></span>
            </div>
            </>
          )}
    </>
  );
}

export default PostJoueur;
